import styled from 'styled-components';

export default function Popup() {
  return (
    <PopUp>
      <PopupLabel>검색 결과가 없습니다.</PopupLabel>
      <PopupLabel>필터를 변경하거나</PopupLabel>
      <PopupLabel>지도를 이동시켜 주세요.</PopupLabel>
    </PopUp>
  );
}

const PopUp = styled.div`
  border-radius: 8px;
  z-index: 1;
  top: 20%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  padding: 16px;
  opacity: 0.5;
  position: absolute;
  background-color: black;
`;

const PopupLabel = styled.div`
  font-family: Pretendard;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
  vertical-align: middle;
  text-align: center;
  color: white;
`;
